import { Translatable } from "@icc/shared/helpers";

/** Typ produktu */
export class RollerShutterType {
    id: number;
    /** Nazwa */
    @Translatable({ model: 'ShutterTypes' })
    name: string;
    /** Kod do wydruków */
    printCode: string;
    /** Grupa typu produktu */
    shutterTypeGroupId: number;
    /** Opis */
    description: string;
    /** Zdjęcie */
    img: string;
    /** Tylko pancerz */
    onlyShutter: boolean;
    /** Z opcją dopasowania do typu produktu */
    fitToTypeAvailable: boolean;
    /** Ma przypisane rodzaje montażu */
    hasMontageTypes: boolean;
    /** Wybór koloru skrzynki */
    boxColorSelection: 'inside_outside' | 'single' | 'none';
    /** Posiada listwę tynkową od zewnątrz */
    hasOutsidePlasterStopBead: boolean;
    /** Posiada listwę tynkową od wewnątrz */
    hasInsidePlasterStopBead: boolean;
    /** Kolejność */
    order?: number;
    /** Posiada różne głębokości dla tej samej wysokości */
    hasMultipleDepthsForHeight?: boolean;
    /** Wybór głębokości skrzynki zamiast wysokości */
    selectBoxDepthInsteadOfHeight?: boolean;
    /** Miejsce klapy rewizyjnej */
    inspectionHatchLocationChoice?: boolean;
    /** Brak poszerzenia między segmentami */
    noWidthExtensionBetweenSegments?: boolean;
    /** Dodatkowe ograniczenie poszerzenia zależne od napędu */
    boxWidthExtensionDriveDependent?: boolean;
    /** Podział moskitiery niezależny od podziału pancerza */
    independentMosquitoDivision?: boolean;
    /** Kolor listwy tynkowej zewnętrznej mapowany z koloru klapy rewizyjnej (brak możliwości ręcznej zmiany) */
    outerPlasterStripColorAuto?: boolean;
    /** Dolny pasek 1,5 cm zewnętrznej pokrywy skrzynki w kolorze okleiny prowadnic, jeśli jest zabudowa skrzynki od zewnątrz */
    bottomStripGuideColorWhenBuiltIn?: boolean;
    /** Dolny pasek 1,5 cm wewnętrznej pokrywy skrzynki w kolorze okleiny klapy rewizyjnej, jeśli jest zabudowa skrzynki od wewnątrz, a klapa rewizyjna jest od dołu */
    bottomStripRevisionColorWhenBuiltIn?: boolean;
    /** Dostępność koloru buforu listwy dolnej */
    endRailBufferColorChoice?: boolean;
    /** Pozwalaj na wybór koloru skrzynki mimo zabudowy */
    allowBoxColorChoiceWhenBuiltIn?: boolean;
    /** Dodatkowa wkładka styropianowa ustawiona domyślnie */
    defaultAdditionalPolystyreneInsert?: boolean;
    /** Izolacja boków skrzynki ustawiona domyślnie */
    defaultBoxSideInsulation?: boolean;
    /** Dopłata za prowadnice dla ustawień koloru skrzynki (JSON array) */
    guideSurchargeBoxSettings?: string | string[];
    /** Szablon wydruku zamówienia */
    orderPrintTemplate?: 'CCTLTP' | 'MX' | 'SN' | 'STOSIT' | null;
    /** Minimalna jednostka rozliczeniowa [m²] */
    minBillingArea?: number | null;
    /** Cena okleiny skrzynki zawiera już okleinowanie klapy rewizyjnej (brak oddzielnej dopłaty za kolor klapy w dekorze) */
    inspectionHatchIncludedInBoxDekor?: boolean;
    /** Nawojowość */
    boxHeights?: BoxHeightOption[];
}

/** Opcja wysokości skrzynki z warunkami nawojowymi */
export interface BoxHeightOption {
    /** Wysokość skrzynki [mm] */
    height: number;
    /** Opcje dla tej wysokości */
    options: BoxHeightCondition[];
}

/** Warunki dla danej wysokości skrzynki */
export interface BoxHeightCondition {
    /** Maksymalna wysokość rolety wraz z skrzynką [mm] */
    maxHeight: number;
    /** Minimalna szerokość [mm] */
    minWidth?: number;
    /** Maksymalna szerokość [mm] */
    maxWidth?: number;
    /** Moskitiera rolowana */
    mosquito?: boolean | null;
    /** ID profilu pancerza */
    profile?: number | null;
    /** ID rury nawojowej (null = niezależnie) */
    reel?: number | null;
    /** Lista ID konsol statycznych (null = niezależnie) */
    staticBracket?: number[] | null;
    /** Wkładka styropianowa */
    polystyreneInsert?: boolean | null;
    /** Rygiel automatyczny */
    automaticBolt?: boolean | null;
    /** Wieszak blokujący */
    blockHanger?: boolean | null;
    /** Wzmocnienie skrzynki */
    boxReinforcement?: boolean | null;
}
